module.exports = __webpack_public_path__ + "img/16_Low-body+GC.ee82e497.png";